export const Services = {
  ORDEN_SERV: {
    path: process.env.REACT_APP_ORDEN_SERV,
    method: "",
    descrp: "API TO HANDLE ORDEN SERVICIO",
  },
  REPORT: {
    path: process.env.REACT_APP_REPORT,
    method: "",
    descrp: "API TO HANDLE REPORT",
  },
};
